import { MarkdownBody } from '@inflearn/ds-markdown-body';
import { Box, Button, Group, Text } from '@inflearn/ds-react';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'next-i18next';

import type { MyProfileResponse } from '../../../../../../../resources/@types/accountSchema';
import { USERS_URL } from '../../../../../../constants/urls';
import { isEmptyMarkdownBody } from '../../../../../../utils/isEmptyMarkdownBody';
import { ProfileSlotGameButton } from '../../../../games/entry/ProfileSlotGameButton';
import { SettingRow } from '../../common/SettingRow';
import { SettingSection } from '../../common/SettingSection';
import { ReadOnlyIntroduce } from './Introduce';
import { ProfileImagePreview } from './ProfileImage';

export const ReadOnlyProfile = ({
  profile,
  openEditMode,
}: {
  profile: MyProfileResponse;
  openEditMode: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <SettingRow label={t('이미지')} align="start">
        <Group spacing={12} align="top">
          <ProfileImagePreview url={profile.profileImageUrl} />
          <ProfileSlotGameButton />
        </Group>
      </SettingRow>
      <SettingRow label={t('닉네임')} align="center">
        {isEmpty(profile.nickname) ? (
          <PlaceholderText text="-" />
        ) : (
          <Text size="md" color="gray.9" weight={600}>
            {profile.nickname}
          </Text>
        )}
      </SettingRow>
      <SettingRow label={t('프로필 주소')} align="center">
        {isEmpty(profile.slug) ? (
          <PlaceholderText text={t('나만의 프로필 주소를 만들어보세요.')} />
        ) : (
          <Text
            component="a"
            href={USERS_URL.HOME({
              userId: profile.id.toString(),
              slug: profile.slug ?? undefined,
            })}
            size="md"
            weight={600}
            color="blue.6"
            underline
          >
            {`inflearn.com/users/@${profile.slug}`}
          </Text>
        )}
      </SettingRow>
      <SettingRow label={t('자기소개')} align="start">
        <Box mt={8} w="100%">
          {isEmptyMarkdownBody(profile.introduce) ? (
            <PlaceholderText text={t('나만의 스킬, 깃허브 링크 등으로 소개글을 채워보세요.')} />
          ) : (
            <ReadOnlyIntroduce>
              <MarkdownBody html={profile.introduce} />
            </ReadOnlyIntroduce>
          )}
        </Box>
      </SettingRow>
      <SettingSection.TopRightSection>
        <Button variant="default" size="sm" onClick={openEditMode}>
          {t('설정')}
        </Button>
      </SettingSection.TopRightSection>
    </>
  );
};

const PlaceholderText = ({ text }: { text: string }) => (
  <Text size="md" color="gray.5">
    {text}
  </Text>
);
